import Moment from "moment";
import { FormatDate } from "../api-client-nswag/taxportal-client";
import { taxPortalClientApi } from "../api-client-nswag/taxportal-client-runtime";
import { FolderNode, FolderTree } from "../api-client-nswag/custompermission-client";

export const convertUTCTimeToLocal = (e: string, format: string = FormatDate.AC) => {
  if (e === null) {
    return "";
  }
  return Moment.utc(e).local().format(format);
};

export const convertFormatDate = (e: string, format: string = FormatDate.HQ) => {
  if (e === null) {
    return "";
  }
  return Moment(e).format(format);
};

export function calculateGridHeight(height: number) {
  const windowHeight = window.innerHeight ?? 600;
  return windowHeight - height;
}

export function calculateGridWidth(width: number) {
  const windowWidth = window.innerWidth;
  return windowWidth - width;
}

export const selectValues = (arr: string[]) =>
  arr.map((value) => ({
    ID: value.toLowerCase(),
    Name: value !== "NULL" ? value : "--",
    disabled: value === "NULL",
  }));

export const becomeUpperCase = (str: string) => str.toUpperCase();

export const toCapitalCase = (str: string) => {
  return !str ? "" : str
    .toLowerCase()
    .split(" ")
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const getExtension = (file: string) => file!.split(".").pop()!;

export const getNewAccessToken = async (type: number) => {
  try {
    const res = await taxPortalClientApi.reports_GetPowerBIToken(type);
    console.log(typeof res, "res");
    return res;
  } catch (error: any) {
    console.error("Error getting new access token:", error);
    window.location.href = `${window.location.origin}/signout`;
    return null;
  }
};
export const timeOutForRefreshToken = (tokenExpiration: Date | null, setTokenTimeout: any, refreshAccessToken: any) => {
  if (tokenExpiration) {
    const currentTime = new Date();
    const refreshTime = tokenExpiration.getTime() - currentTime.getTime() - 5 * 60 * 1000;
    if (refreshTime > 0) {
      setTokenTimeout(setTimeout(refreshAccessToken, refreshTime));
    }
  }
};

export const getCurrentUTCTimestamp = () => {
  return Moment.utc().format();
};

export const executeDownload = (
  base64String: string | ArrayBuffer,
  identifier: string,
  fieName: string,
  fileExtension: string
) => {
  const blobArray = typeof base64String === "string" ? defineBlob(base64String) : base64String;

  const type =
    fileExtension === "xlsx" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "application/zip";

  const blob = new Blob([blobArray], { type });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const currentTime = convertUTCTimeToLocal(getCurrentUTCTimestamp(), FormatDate.NAME);
  link.setAttribute("download", `${identifier}${fieName}${currentTime}.${fileExtension}`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) link.parentNode.removeChild(link);
};

const defineBlob = (base64String: string) => {
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  return new Uint8Array(byteNumbers);
};

export const downloadExcelFile = (arrayBuffer: ArrayBuffer, fileName: string = "RejectedRecords.xlsx") => {
  const blob = new Blob([arrayBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const flattenFolderTree = (tree: FolderTree): FolderNode[] => {
  const out: FolderNode[] = [];
  const stack: FolderNode[] = [...tree];
  while (stack.length) {
    const node = stack.pop()!;
    out.push(node);
    if (node.children?.length) stack.push(...node.children);
  }
  return out;
};

export const makeUsersMap = (tree: FolderTree): Map<number, string[]> => {
  const map = new Map<number, string[]>();
  for (const n of flattenFolderTree(tree)) {
    map.set(n.folderId, n.users ?? []);
  }
  return map;
};

export function areArraysEqual(a: string[], b: string[]) {
  if (a.length !== b.length) return false
  const setA = new Set(a)
  return b.every((id) => setA.has(id))
}

export const formatMembersCount = (count: number) => `${count} ${count === 1 ? "Member" : "Members"}`;

export const formatUsersCount = (count: number) => `${count} ${count === 1 ? "User" : "Users"}`;

export function getDaysDifference(
  fromDate?: string | Date | null,
  toDate?: string | Date | null
): number {
  if (!fromDate || !toDate) return 0;

  const MS_PER_DAY = 24 * 60 * 60 * 1000;

  function toUTCDateOnly(input: string | Date): number {
    if (typeof input === "string") {
      const match = input.trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!match) return NaN;

      const year = Number(match[1]);
      const month = Number(match[2]) - 1;
      const day = Number(match[3]);

      return Date.UTC(year, month, day);
    }

    if (isNaN(input.getTime())) return NaN;

    return Date.UTC(
      input.getFullYear(),
      input.getMonth(),
      input.getDate()
    );
  }

  const startUTC = toUTCDateOnly(fromDate);
  const endUTC = toUTCDateOnly(toDate);

  if (isNaN(startUTC) || isNaN(endUTC)) return 0;

  return Math.abs((endUTC - startUTC) / MS_PER_DAY);
}

export const formatDateForAPI = (date: any): string | undefined => {
  if (!date) return undefined;

  try {
    const d = new Date(date);
    if (isNaN(d.getTime())) return undefined;

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch {
    return undefined;
  }
};
